import React from 'react'

import { GridColumn } from '../../../components/grid/grid-column.js'
import { Grid } from '../../../components/grid/grid.js'
import { NotificationCard, NotificationCardProps } from '../../../components/notification-card/notification-card.js'
import { PageTitle, PageTitleProps } from '../../../components/page-title/page-title.js'
import { SubscriptionCard, SubscriptionCardProps } from '../../../components/subscription-card/subscription-card.js'
import { UpgradeCard, UpgradeCardProps } from '../../../components/upgrade-card/upgrade-card.js'
import { ViewBase, ViewBaseProps } from '../../base/base.js'

export interface SingleSubscriptionProps {
    title: PageTitleProps
    card: SubscriptionCardProps
    upgradeCards?: UpgradeCardProps[]
    notificationCards?: NotificationCardProps[]
}

export interface ViewSingleSubscriptionProps extends SingleSubscriptionProps, ViewBaseProps {}

export const SingleSubscription = (props: SingleSubscriptionProps): JSX.Element => (
    <div className="text">
        <PageTitle {...props.title} />
        <Grid className="text__margin-double">
            <GridColumn width={['md-6', 'xl-4']}>
                <Grid>
                    <GridColumn width={['xs-12']}>
                        <SubscriptionCard {...props.card} />
                    </GridColumn>

                    {props.notificationCards?.map((notification, index) => (
                        <GridColumn width={['xs-12']} key={index}>
                            <NotificationCard {...notification} />
                        </GridColumn>
                    ))}
                </Grid>
            </GridColumn>
            {props.upgradeCards && (
                <GridColumn width={['md-6', 'xl-8']}>
                    <Grid>
                        {props.upgradeCards?.map((item: UpgradeCardProps, index: number) => (
                            <GridColumn width={['xl-6']} key={index}>
                                <UpgradeCard {...item} />
                            </GridColumn>
                        ))}
                    </Grid>
                </GridColumn>
            )}
        </Grid>
    </div>
)

export const ViewSingleSubscription = (props: ViewSingleSubscriptionProps): JSX.Element => (
    <ViewBase {...props}>
        <SingleSubscription {...props} />
    </ViewBase>
)
